import Topnavbar from "../../../Layouts/Topnavbar";
import { Container, Grid, Paper, Text, Title, Group, ThemeIcon, Button, Drawer, Select, Modal, Switch, Stack, SimpleGrid, TextInput, Textarea, PasswordInput, Center, Box, Progress, Badge, NumberInput, PinInput, Checkbox, Skeleton } from "@mantine/core";
import React, { useState, useEffect } from "react";
import {
    Table,
    Tag,
    Typography,
    Row,
    Col,
    DatePicker,
    Input,
    Space,
    Card, message, Descriptions, Divider, Empty, Spin,
    Alert,
} from "antd";
import { Userauthcontexthooks } from "../../../Hooks/Userauthcontexthooks";
import dayjs from "dayjs";
import { Admin_Bank_Add, Admin_Bank_Delete, Admin_Banks_get, Get_All_Users, Get_Individual_user_wallet_details, Get_Portal_Configuration, Master_Dist_Signup, Portal_Configuration, Sendotp, Update_Master_dist_details, Update_user_wallet_hold_balance, Update_user_wallet_status } from "../../../apicall";
import { IconCheck, IconX } from "@tabler/icons-react";
import {
    IconWorld,
    IconUsers,
    IconBuildingStore,
    IconShieldCheck
} from "@tabler/icons-react";
const { Search } = Input;










const Portalconfig = ({ Headername }) => {
    const { user } = Userauthcontexthooks();
    const [configMoadl, setConfigModal] = useState(false);
    const [fetchedConfigurations, setfetchedConfigurations] = useState('');
    const [fetchedConfigurationsloading, setfetchedConfigurationsloading] = useState(true);
    const [portalConfig, setPortalConfig] = useState({
        allPortal: false,
        retailerPortal: false,
        distributorPortal: false,
    });
    const [Submitconfigloading, setConfigloading] = useState(false);
    const [Inputotp, setInputotp] = useState('');
    const [otpTimer, setOtpTimer] = useState(0);
    const [otploading, setotploading] = useState(false);
    const hasChanges =
        fetchedConfigurations &&
        (
            portalConfig.allPortal !== fetchedConfigurations.IsAllPortalDown ||
            portalConfig.retailerPortal !== fetchedConfigurations.IsRetailerPortalDown ||
            portalConfig.distributorPortal !== fetchedConfigurations.IsDistributorPortalDown
        );

    const SentOTP = async (purpose) => {
        if (!purpose) {
            message.error('Purpose is not define');
            return;
        }
        try {
            setotploading(true);
            const data = await Sendotp(purpose);
            if (data.success) {
                message.success('OTP is sent in your registerd mail id');
                setOtpTimer(60); // Start 60 sec countdown
                return;
            }
        } catch (error) {
            console.log(error);
            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );
        } finally {
            setotploading(false);
        }

    }

    const fetchPortalConfigs_status = async () => {
        try {
            const data = await Get_Portal_Configuration();
            if (data.success) {
                //console.log(data);
                setfetchedConfigurations(data?.Configuration);
                setPortalConfig({
                    allPortal: data.Configuration.IsAllPortalDown,
                    retailerPortal: data.Configuration.IsRetailerPortalDown,
                    distributorPortal: data.Configuration.IsDistributorPortalDown,
                });
            }
        } catch (error) {
            console.log(error);
            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );
        } finally {
            setfetchedConfigurationsloading(false);
        }
    }

    const Change_Config_portals = async () => {
        if (!hasChanges) {
            message.error('Kindly changes first');
            return;
        }
        if (!Inputotp) {
            message.error('OTP is required');
            return;
        }
        const body = {
            IsAllPortalDown: portalConfig.allPortal,
            IsRetailerPortalDown: portalConfig.retailerPortal,
            IsDistributorPortalDown: portalConfig.distributorPortal,
            otp: Inputotp
        }
        try {
            setConfigloading(true);
            const data = await Portal_Configuration(body);
            if (data.success) {
                message.success(data?.message);
                setConfigModal(false);
                setInputotp('');
                fetchPortalConfigs_status();
                return;
            }
        } catch (error) {
            console.log(error);
            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );
        } finally {
            setConfigloading(false);
        }

    }


    useEffect(() => {
        const fetchPortalConfigs_status = async () => {
            try {
                const data = await Get_Portal_Configuration();
                if (data.success) {
                    //console.log(data);
                    setfetchedConfigurations(data?.Configuration);
                    setPortalConfig({
                        allPortal: data.Configuration.IsAllPortalDown,
                        retailerPortal: data.Configuration.IsRetailerPortalDown,
                        distributorPortal: data.Configuration.IsDistributorPortalDown,
                    });
                }
            } catch (error) {
                console.log(error);
                message.error(
                    error.response?.data?.message ||
                    "Something went wrong."
                );
            } finally {
                setfetchedConfigurationsloading(false);
            }
        }

        if (user) {
            fetchPortalConfigs_status();
        }

    }, [user])

    useEffect(() => {
        if (otpTimer <= 0) return;

        const interval = setInterval(() => {
            setOtpTimer((prev) => prev - 1);
        }, 1000);

        return () => clearInterval(interval);
    }, [otpTimer]);

    return (
        <>
            <Topnavbar Headername={Headername} />
            <Container size={'xl'} mt={'sm'}>
                <Title c={'dimmed'}>Portal Configurations</Title>
                <Text size="xs">You can Active/Inactive Portals.</Text>
            </Container>
            {/* <Group justify="flex-end" mt="sm" mr={'md'}>
                <Button
                    variant="light"
                    onClick={() => setCreateModal(true)}

                >
                    Create Banks
                </Button>
            </Group> */}
            <Container size={'lg'} mt={'lg'}>
                <SimpleGrid cols={{ base: 1, sm: 2, lg: 3 }}>

                    {/* All Portal */}
                    <Skeleton visible={fetchedConfigurationsloading}>
                        <Card shadow="sm" radius="md" withBorder>

                            <Group justify="space-between">

                                <ThemeIcon
                                    color="red"
                                    size={50}
                                    radius="xl"
                                    variant="light"
                                >
                                    <IconWorld size={28} />
                                </ThemeIcon>

                                <Badge
                                    color={
                                        portalConfig.allPortal
                                            ? "red"
                                            : "green"
                                    }
                                    size="lg"
                                >
                                    {portalConfig.allPortal
                                        ? "DOWN"
                                        : "LIVE"}
                                </Badge>

                            </Group>

                            <Stack mt="md" gap={5}>

                                <Text fw={700} size="lg">
                                    All Portal
                                </Text>

                                <Text size="sm" c="dimmed">
                                    Disable every portal immediately including
                                    Retailer, Distributor & Admin access.
                                </Text>

                            </Stack>

                            <Divider my="md" />

                            <Group justify="space-between">

                                <Text fw={600}>
                                    Portal Status
                                </Text>

                                <Switch
                                    size="lg"
                                    color="red"
                                    checked={portalConfig.allPortal}
                                    onChange={(event) => {
                                        const checked = event.target.checked;
                                        setPortalConfig((prev) => ({
                                            ...prev,
                                            allPortal: checked,
                                        }));
                                    }}
                                />

                            </Group>

                        </Card>
                    </Skeleton>


                    {/* Retailer */}
                    <Skeleton visible={fetchedConfigurationsloading}>
                        <Card shadow="sm" radius="md" withBorder>

                            <Group justify="space-between">

                                <ThemeIcon
                                    color="blue"
                                    size={50}
                                    radius="xl"
                                    variant="light"
                                >
                                    <IconBuildingStore size={28} />
                                </ThemeIcon>

                                <Badge
                                    color={
                                        portalConfig.retailerPortal
                                            ? "red"
                                            : "green"
                                    }
                                    size="lg"
                                >
                                    {portalConfig.retailerPortal
                                        ? "DOWN"
                                        : "LIVE"}
                                </Badge>

                            </Group>

                            <Stack mt="md" gap={5}>

                                <Text fw={700} size="lg">
                                    Retailer Portal
                                </Text>

                                <Text size="sm" c="dimmed">
                                    Restrict only retailer users from logging in
                                    and performing transactions.
                                </Text>

                            </Stack>

                            <Divider my="md" />

                            <Group justify="space-between">

                                <Text fw={600}>
                                    Portal Status
                                </Text>

                                <Switch
                                    size="lg"
                                    color="red"
                                    checked={portalConfig.retailerPortal}
                                    onChange={(event) => {
                                        const checked = event.target.checked;
                                        setPortalConfig((prev) => ({
                                            ...prev,
                                            retailerPortal: checked,
                                        }));
                                    }}

                                />

                            </Group>

                        </Card>
                    </Skeleton>


                    {/* Distributor */}
                    <Skeleton visible={fetchedConfigurationsloading}>
                        <Card shadow="sm" radius="md" withBorder>

                            <Group justify="space-between">

                                <ThemeIcon
                                    color="orange"
                                    size={50}
                                    radius="xl"
                                    variant="light"
                                >
                                    <IconUsers size={28} />
                                </ThemeIcon>

                                <Badge
                                    color={
                                        portalConfig.distributorPortal
                                            ? "red"
                                            : "green"
                                    }
                                    size="lg"
                                >
                                    {portalConfig.distributorPortal
                                        ? "DOWN"
                                        : "LIVE"}
                                </Badge>

                            </Group>

                            <Stack mt="md" gap={5}>

                                <Text fw={700} size="lg">
                                    Distributor Portal
                                </Text>

                                <Text size="sm" c="dimmed">
                                    Disable Distributor & Master Distributor
                                    access while Retailers continue working.
                                </Text>

                            </Stack>

                            <Divider my="md" />

                            <Group justify="space-between">

                                <Text fw={600}>
                                    Portal Status
                                </Text>

                                <Switch
                                    size="lg"
                                    color="red"
                                    checked={portalConfig.distributorPortal}
                                    onChange={(event) => {
                                        const checked = event.target.checked;
                                        setPortalConfig((prev) => ({
                                            ...prev,
                                            distributorPortal: checked,
                                        }));
                                    }}
                                />

                            </Group>

                        </Card>
                    </Skeleton>
                </SimpleGrid>
                <Card
                    style={{ marginTop: '10px' }}
                >

                    <Group justify="space-between">

                        <Group>

                            <ThemeIcon
                                color="green"
                                variant="light"
                                radius="xl"
                            >
                                <IconShieldCheck size={18} />
                            </ThemeIcon>

                            <div>

                                <Text fw={700}>
                                    Configuration Status
                                </Text>

                                <Text size="sm" c="dimmed">
                                    Changes will immediately affect portal accessibility.
                                </Text>

                            </div>

                        </Group>

                        <Button
                            disabled={!hasChanges}
                            onClick={() => setConfigModal(true)}
                        >
                            Save Configuration
                        </Button>

                    </Group>

                </Card>
            </Container>


            <Modal
                opened={configMoadl}
                onClose={() => setConfigModal(false)}
                title="Configure Portal"
                size="md"
                centered
            >
                <Alert title="Are you sure want to change portal status? Verify first your identitty" type="warning" />
                <Group justify="space-evenly" align="end" mt={'xs'}>
                    <TextInput
                        label="OTP"
                        placeholder="Enter OTP"
                        size="sm"
                        name="otp"
                        value={Inputotp}
                        onChange={(e) => setInputotp(e.target.value)}
                        withAsterisk
                        type="password"
                    />

                    {otpTimer > 0 ? (
                        <Button disabled variant="light">
                            {`Resend in ${otpTimer}s`}
                        </Button>
                    ) : (
                        <Button
                            loading={otploading}
                            onClick={() => SentOTP("Verify Identity")}
                            variant="outline"
                            disabled={!hasChanges}
                        >
                            Send OTP
                        </Button>
                    )}
                </Group>

                <Group justify="flex-end" mt="xs">
                    {otpTimer > 0 && (
                        <Text size="xs" c="dimmed" fw={600}>
                            Resend OTP in {otpTimer} sec
                        </Text>
                    )}

                </Group>

                <Group justify="flex-end" mt="xl">

                    <Button
                        variant="default"
                        onClick={() => setConfigModal(false)}
                    >
                        Cancel
                    </Button>

                    <Button
                        loading={Submitconfigloading}
                        onClick={Change_Config_portals}
                    >
                        Confirm
                    </Button>

                </Group>
            </Modal>


        </>
    )
}

export default Portalconfig;